var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-x grid-padding-x" }, [
    _c("div", { staticClass: "cell", class: _vm.divClass }, [
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("First Name")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.first_name }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Surname")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.last_name }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Known As")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.known_as }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Email Address")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.email }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Mobile Number")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.cellphone_1 }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("ID Number")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.id_number }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Province")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: {
            value: _vm.jobApplication.user.province
              ? _vm.jobApplication.user.province.title
              : null
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Country")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: {
            value: _vm.jobApplication.user.country
              ? _vm.jobApplication.user.country.title
              : null
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Address")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.address }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Ethnicity")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: {
            value: _vm.jobApplication.user.ethnicity
              ? _vm.jobApplication.user.ethnicity.title
              : null
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Employment Status")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: {
            value: _vm.jobApplication.user.employment_status
              ? _vm.jobApplication.user.employment_status.title
              : null
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Current Salary")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.current_salary }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Desired Salary")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.jobApplication.user.desired_salary }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control mt-3" }, [
        _c("label", [
          _vm._v(
            "Are you a citizen of the country you are seeking employment in?"
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "1",
                disabled: !_vm.jobApplication.user.is_citizen
              },
              domProps: { checked: !!_vm.jobApplication.user.is_citizen }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        Yes\n                    ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "0",
                disabled: !!_vm.jobApplication.user.is_citizen
              },
              domProps: { checked: !_vm.jobApplication.user.is_citizen }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        No\n                    ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("ID Document")]),
        _vm._v(" "),
        _vm.jobApplication.user.id_path
          ? _c("input", {
              attrs: { type: "text", disabled: "" },
              domProps: { value: "" + _vm.jobApplication.user.id_path_cdn }
            })
          : _c("p", { staticClass: "fw-light" }, [_vm._v("No file attached.")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Drivers License")]),
        _vm._v(" "),
        _vm.jobApplication.user.drivers_licence_path
          ? _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "" + _vm.jobApplication.user.drivers_licence_path_cdn
                }
              },
              [_vm._v(_vm._s(_vm.jobApplication.user.drivers_licence_path_cdn))]
            )
          : _c("p", { staticClass: "fw-light" }, [_vm._v("No file attached.")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Do you have any disabilities or conditions? ")]),
        _vm._v(" "),
        _c("p", { staticClass: "fw-light mb-2" }, [
          _vm._v("Eg. physical, mental, diabetes, epilepsy etc.")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "1",
                disabled: !_vm.jobApplication.user.disabilities_and_disorders
              },
              domProps: {
                checked: !!_vm.jobApplication.user.disabilities_and_disorders
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        Yes\n                    ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control" }, [
            _c("input", {
              attrs: { type: "text", disabled: "" },
              domProps: {
                value: _vm.jobApplication.user.disabilities_and_disorders
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "0",
                disabled: !!_vm.jobApplication.user.disabilities_and_disorders
              },
              domProps: {
                checked: !_vm.jobApplication.user.disabilities_and_disorders
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        No\n                    ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [
          _vm._v("Have you ever worked for Merchants in the past? ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "1",
                disabled: !_vm.jobApplication.user
                  .is_worked_for_merchant_in_the_past
              },
              domProps: {
                checked: !!_vm.jobApplication.user
                  .is_worked_for_merchant_in_the_past
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        Yes\n                    ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "0",
                disabled: !!_vm.jobApplication.user
                  .is_worked_for_merchant_in_the_past
              },
              domProps: {
                checked: !_vm.jobApplication.user
                  .is_worked_for_merchant_in_the_past
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        No\n                    ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Are you currently working for Merchantst? ")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "1",
                disabled: !_vm.jobApplication.user
                  .currently_working_for_merchant
              },
              domProps: {
                checked: !!_vm.jobApplication.user
                  .currently_working_for_merchant
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        Yes\n                    ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
            _c("input", {
              attrs: {
                type: "radio",
                value: "0",
                disabled: !!_vm.jobApplication.user
                  .currently_working_for_merchant
              },
              domProps: {
                checked: !_vm.jobApplication.user.currently_working_for_merchant
              }
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v("\n                        No\n                    ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control" }, [
        _c("label", [_vm._v("Were you referred by someone? ")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
          _c("input", {
            attrs: {
              type: "radio",
              value: "1",
              disabled: !_vm.jobApplication.user.is_referred
            },
            domProps: { checked: !!_vm.jobApplication.user.is_referred }
          }),
          _vm._v(" "),
          _c("label", [_vm._v("\n                    Yes\n                ")])
        ]),
        _vm._v(" "),
        _vm.jobApplication.user.is_referred
          ? _c(
              "div",
              {
                staticClass: "grid-x grid-padding-x",
                staticStyle: { "padding-left": "10px" }
              },
              [
                _c("div", { staticClass: "cell small-6 form-control" }, [
                  _c("label", [_vm._v("First Name")]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "text", disabled: "" },
                    domProps: {
                      value: _vm.jobApplication.user.referral_first_name
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell small-6 form-control" }, [
                  _c("label", [_vm._v("First Name")]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "text", disabled: "" },
                    domProps: {
                      value: _vm.jobApplication.user.referral_last_name
                    }
                  })
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("label", [_vm._v("Business Unit")]),
        _vm._v(" "),
        _c("div", { staticClass: "form-control" }, [
          _c("input", {
            attrs: { type: "text", disabled: "" },
            domProps: {
              value: _vm.jobApplication.user.company
                ? _vm.jobApplication.user.company.title
                : null
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center yes-no-item" }, [
          _c("input", {
            attrs: {
              type: "radio",
              value: "0",
              disabled: !!_vm.jobApplication.user.is_referred
            },
            domProps: { checked: !_vm.jobApplication.user.is_referred }
          }),
          _vm._v(" "),
          _c("label", [_vm._v("\n                    No\n                ")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52696fb5", { render: render, staticRenderFns: staticRenderFns })
  }
}